import type { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { toggle } from 'Core/actions/request';
import { useDispatch } from 'Core/store';
import { cloneSafe } from 'Utils/components';

import type { CommonParams, FacetCommonProps } from '../baseFacet';

type Params = CommonParams & {
  isToggled: boolean;
  toggleFacet: () => void;
};

const ToggleFacet: FunctionComponent<FacetCommonProps<Params>> = ({
  facet,
  templateFunc,
  config,
  facetRef,
  commonParams,
}) => {
  const dispatch = useDispatch();
  const [toggledByUser, setToggledByUser] = useState(false);

  const {
    term = '',
    initToggled,
    isInverted,
  } = config.type === 'toggleFacet' && typeof config.term === 'string' ? config : {};
  const { field, facetedValues, facetedSelection } = facet;

  const isTermSelected = !!facetedSelection.find((f) => f.term === term)?.isSelected;
  const isTermAvailable = facetedValues.some((f) => f.term === term);

  useEffect(() => {
    if (initToggled && !toggledByUser && !isTermSelected) {
      dispatch(toggle({ field, term }));
    }
  }, [dispatch, field, initToggled, isTermSelected, term, toggledByUser]);

  if (!isTermAvailable) {
    return null;
  }

  const toggleFacet = () => {
    setToggledByUser(true);
    dispatch(toggle({ field, term }));
  };

  const component = templateFunc.call({
    ...commonParams,
    isToggled: isInverted ? !isTermSelected : isTermSelected,
    toggleFacet,
  });

  return cloneSafe(component, facetRef);
};

export default ToggleFacet;
